import { useState } from "react";
import classes from "./style.module.scss";
import modusLogo from "../../../asset/Modus_logo.png";
import { useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import LogoutModal from "../../Modals/LogoutModal/logoutModal";
import { setCurrentTab } from "../../../redux/ducks/auth";
import { useDispatch } from "react-redux";

const Header = ({ onOpenActivity }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const handleOnClickLogout = () => {
    setOpenLogoutModal(!openLogoutModal);
  };
  return (
    <>
      <div className={classes["header-container"]}>
        <div className={classes["logo"]} onClick={() => navigate("/base/home")}>
          <img src={modusLogo} alt="" />
        </div>

        {/* new div for the activities tab */}
        
        <div className={classes["nav-items"]}>
          <div className={classes["activity-button"]}>
            <button onClick={onOpenActivity} >
              Activity
            </button>
          </div>
          <div
            className={classes["logout-btn"]}
            onClick={() => {
              handleOnClickLogout();
            }}
          >
            <span>Log out</span>
          </div>
          <div
            className={classes["myAccount-btn"]}
            onClick={() => {
              dispatch(setCurrentTab(0)); // 0 => profile page
              navigate("/base/profile");
            }}
          >
            My account
          </div>
        </div>
      </div>
      <Modal
        open={openLogoutModal}
        onClose={handleOnClickLogout}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <LogoutModal closeModal={handleOnClickLogout} />
      </Modal>
    </>
  );
};

export default Header;